export class NewsParameters{
    public numberNews?: number;
    public starting?: number;
    public month?: number | null;
    public year?: number | null;
    public search?: string;
    public slug?: string;
    public lang?:string;
    public preview?:boolean;
}